module.exports = __webpack_public_path__ + "img/datu.a1e0164e.png";